export default {
    query: {
        form_fixed: true
    },
    table: {
        border: true,
        stripe: true,
        align: 'center'
    },
    localeList: [
        {value: 'zhCn', label: '简体中文'},
        {value: 'en', label: 'English'}
    ],
    menu:{
        // bg_color:'#101010',
        unique_opened: false,
        url:'sysMenuCmService.getUserMenu'
    },

}

